import React, { useState } from 'react';
import './BurgerMenu.css';

interface BurgerMenuProps {
  viewMode: 'map' | 'action';
  onMapClick: () => void;
  onActionClick: () => void;
  onFullHPClick: () => void;
  onFullStaminaClick: () => void;
  onAIToggleClick: () => void;
  onSettingsClick: () => void;
  onLoreCodexClick: () => void;
  onLeaveGameClick: () => void;
  isInCombat: boolean;
  isQuestActive?: boolean;
  aiStoriesEnabled: boolean;
}

export const BurgerMenu: React.FC<BurgerMenuProps> = ({
  viewMode,
  onMapClick,
  onActionClick,
  onFullHPClick,
  onFullStaminaClick,
  onAIToggleClick,
  onSettingsClick,
  onLoreCodexClick,
  onLeaveGameClick,
  isInCombat,
  isQuestActive = false,
  aiStoriesEnabled,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleMenuItemClick = (action: () => void) => {
    action();
    setIsOpen(false); // Close menu after clicking an item
  };

  const handleViewToggle = () => {
    if (viewMode === 'map') {
      onActionClick();
    } else {
      onMapClick();
    }
  };

  return (
    <div className="burger-menu-container">
      <div className="mobile-nav-buttons">
      <button 
        className={`burger-icon ${isOpen ? 'open' : ''}`} 
        onClick={toggleMenu} 
        aria-label="Toggle menu"
        data-no-sync="true"
      >
        <div className="bar1"></div>
        <div className="bar2"></div>
        <div className="bar3"></div>
      </button>

            <button
          className={`map-button ${viewMode === 'map' ? 'active' : ''}`}
          onClick={handleViewToggle}
              disabled={(isInCombat || isQuestActive) && viewMode === 'action'}
              title={
                (isInCombat || isQuestActive) && viewMode === 'action'
                  ? (isQuestActive ? "Cannot view map during quest" : "Cannot view map during combat")
                  : viewMode === 'map' ? "View Story" : "View Map"
              }
              data-no-sync="true"
              style={{
                opacity: ((isInCombat || isQuestActive) && viewMode === 'action') ? 0.5 : 1,
                cursor: ((isInCombat || isQuestActive) && viewMode === 'action') ? 'not-allowed' : 'pointer',
              }}
            >
              {viewMode === 'map' ? '📖 STORY' : '🗺️ MAP'}
            </button>
      </div>
            
      {isOpen && (
        <div className="burger-menu-overlay" onClick={toggleMenu}>
          <div className="burger-menu-panel" onClick={(e) => e.stopPropagation()}>
            <button
              className="burger-menu-button"
              onClick={() => handleMenuItemClick(onFullHPClick)}
              title="Reset HP to Full"
              data-no-sync="true"
            >
              ❤️ FULL HP
            </button>
            
            <button
              className="burger-menu-button"
              onClick={() => handleMenuItemClick(onFullStaminaClick)}
              title="Reset Stamina to Full (for testing)"
              data-no-sync="true"
            >
              ⚡ FULL STAMINA
            </button>
            
            <button
              className="burger-menu-button"
              onClick={() => handleMenuItemClick(onAIToggleClick)}
              title={aiStoriesEnabled ? "Disable AI Stories (save API costs)" : "Enable AI Stories"}
              style={{ 
                backgroundColor: aiStoriesEnabled ? '#4a7c59' : '#666', 
                opacity: aiStoriesEnabled ? 1 : 0.7 
              }}
              data-no-sync="true"
            >
              {aiStoriesEnabled ? '🤖 AI: ON' : '🔇 AI: OFF'}
            </button>
            
            <button
              className="burger-menu-button"
              onClick={() => handleMenuItemClick(onSettingsClick)}
              title="Settings"
              data-no-sync="true"
            >
              ⚙️ SETTINGS
            </button>
            
            <button
              className="burger-menu-button"
              onClick={() => handleMenuItemClick(onLoreCodexClick)}
              title="View your discovered lore"
              data-no-sync="true"
            >
              📚 LORE CODEX
            </button>
            
            <button
              className="burger-menu-button leave-game-button"
              onClick={() => handleMenuItemClick(onLeaveGameClick)}
              title="Return to world selection"
              data-no-sync="true"
            >
              🚪 LEAVE GAME
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
